import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authReducer from './authSlice';
import cartReducer from './cartSlice';
import featureReducer from './featuresSlice';
import wishlistReducer from './wishSlice';

// 1. First combine your reducers
const rootReducer = combineReducers({
  auth: authReducer,
  cart: cartReducer,
  features: featureReducer,
  wishlist: wishlistReducer  
});

// 2. Then apply persistence
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'cart', 'features', 'wishlist']
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// 3. Create store
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE']
      }
    })
});

export const persistor = persistStore(store);
export default store;
